import React from 'react';
import PropTypes from 'prop-types';

import sAction from 'sAction';

const SweetSpotItem = (props) => {
    const data = props.data;
    let icon = null;

    if (data.icon) {
        const title = data.module? sAction.translate('LBL_MODULE_NAME', data.module) : data.name;
        icon = <div className={'SweetSpotIcon '+data.icon} title={title} />;
    }

    const handleClick = (data) => {
        sAction.sweetSpotAction({item: data, index: null});
    };

    return (<div className={'SweetSpotItem'+props.pomClass}
        onClick={() => handleClick(data)}>
        {icon}
        <div className="SweetSpotItemValue">{sAction.translate(data.name, data.module)}</div>
    </div>);
};

SweetSpotItem.propTypes = {
    data: PropTypes.object,
    icon: PropTypes.string,
    pomClass: PropTypes.string,
};

export default SweetSpotItem;
